import axios from 'axios'
import { showToast } from 'vant'
import { API_BASE } from '@/utils/api-url'
import {
  NETWORK_ERROR_MESSAGE_TEXT,
  TIMEOUT_ERROR_MESSAGE_TEXT,
  clearWebsiteAuthSession,
  extractErrorMessage,
  isAuthExpiredResponse,
  isApiSuccess
} from '@/utils/http-error'

const request = axios.create({
  baseURL: API_BASE,
  timeout: 15000
})

request.interceptors.response.use(
  response => {
    const result = response.data
    if (!isApiSuccess(result)) {
      const message = extractErrorMessage(result, '请求失败，请稍后重试')
      if (!response.config?.skipErrorToast) {
        showToast({ message, type: 'fail' })
      }
      return Promise.reject(new Error(message))
    }
    return result
  },
  error => {
    const responseData = error.response?.data
    if (
      isAuthExpiredResponse(error.response, responseData)
      && localStorage.getItem('dzzj_website_token')
    ) {
      clearWebsiteAuthSession()
    }
    const fallback = error.response
      ? `请求失败，请稍后重试（HTTP ${error.response.status}）`
      : error.code === 'ECONNABORTED'
        ? TIMEOUT_ERROR_MESSAGE_TEXT
        : NETWORK_ERROR_MESSAGE_TEXT
    const message = extractErrorMessage(responseData, fallback)
    if (!error.config?.skipErrorToast) {
      showToast({ message, type: 'fail' })
    }
    return Promise.reject(new Error(message))
  }
)

export default request
